<template>
<div class="container">
  <div class="main">
    <div class="thumb-example">

      <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
        <swiper-slide class="slide-2"
          v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}"
        ></swiper-slide>
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
        <swiper-slide class="slide-2" v-for="(item,i) in picData" :key="i"
          :style="{ 'background-image': 'url('+ item +')'}">
        </swiper-slide>
      </swiper>

    </div>
  </div>
</div>

</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    name: 'swiper-example-thumbs-gallery',
    title: 'Thumbs gallery with Two-way control',
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        swiperOptionTop: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          lazy: {
            loadPrevNext: true
          },
        },
        swiperOptionThumbs: {
          loop: true,
          loopedSlides: 5, // looped slides should be the same
          spaceBetween: 10,
          centeredSlides: true,
          slidesPerView: 'auto',
          touchRatio: 0.2,
          slideToClickedSlide: true ,
        } ,
        picData : [
          'https://dixcel.cn/prod/2016polocup第三站上海/1.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/2.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/3.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/4.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/5.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/6.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/7.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/8.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/9.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/10.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/11.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/12.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/13.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/14.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/15.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/16.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/17.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/18.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/19.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/20.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/21.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/22.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/23.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/24.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/25.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/26.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/27.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/28.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/29.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/30.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/31.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/32.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/33.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/34.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/35.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/36.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/37.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/38.jpg',
          'https://dixcel.cn/prod/2016polocup第三站上海/39.jpg',
        ]
      }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.$swiper
        const swiperThumbs = this.$refs.swiperThumbs.$swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    background-color : #000
    .box_one
      width: 100%;

    .box_bottom
      width: 100%;
      background-color #000


  .main {
    margin-bottom: 5px;
    width: 1003px;
    background-color: #fff;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    padding: 62px 50px 52px;
  }

  .thumb-example {
    height: 680px;
    background-color: $black;
  }
  .swiper {
    .swiper-slide {
      background-size: 100%;
      background-position: center center;
      background-repeat no-repeat
    }
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    &.gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
      padding: $gap 0;
    }
    &.gallery-thumbs .swiper-slide {
      width: 20%;
      height: 100%;
      opacity: 0.4;
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
</style>
